import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from './main/main.component';
import {BetaPageComponent} from './beta-page/beta-page.component';
import {VerifyPageComponent} from './verify-page/verify-page.component';

const routes: Routes = [
  {path: '', component: MainComponent},
  {path: '#', component: MainComponent},
  {path: 'beta', component: BetaPageComponent},
  {path: 'verify', component: VerifyPageComponent}
];

export const appRouting = RouterModule.forRoot(routes);
